/**
 * Outcome of a billing card verification that went through the bank's
 * 3-D Secure page. The server (`/api/public/billing/card-setup/...`) sends
 * the browser back to the CRM page the merchant started from with
 * `?card_setup=verified|declined|expired`. Read once, then removed from the
 * address bar so a reload does not replay the message.
 */
export type CardSetupReturn = 'verified' | 'declined' | 'expired'

export function readCardSetupReturn(): CardSetupReturn | null {
	if (typeof window === 'undefined') return null
	const url = new URL(window.location.href)
	const value = url.searchParams.get('card_setup')
	if (value !== 'verified' && value !== 'declined' && value !== 'expired') return null
	url.searchParams.delete('card_setup')
	window.history.replaceState(window.history.state, '', url.toString())
	return value
}

export const CARD_SETUP_RETURN_ERRORS: Record<Exclude<CardSetupReturn, 'verified'>, string> = {
	declined: 'Your bank did not approve this card. Please try again or use another card.',
	expired: 'The card verification took too long. Please enter your card again.',
}

/** Where the bank sends the merchant back: this page, without its query string. */
export function currentPageReturnUrl(): string {
	return `${window.location.origin}${window.location.pathname}`
}
